import { useEffect } from 'react';
import type { EsaResolveHilPayload } from '@growthaxl/web-foundation';
import { shellEventBus } from '../../../shell/events/eventBus';
import {
  setResolvingTab as bridgeSetResolvingTab,
} from '../../../shell/events/resolvingTabBridge';
import { useShellStore } from '../../../shell/store/shellStore';
import { useEsaDomainStore } from '../store/esaDomainStore';
import { buildResolvingTabSpec } from '../utils/buildResolvingTabSpec';
import type { InboxItem, ResolvingSession } from '../types';

function payloadToInboxItem(payload: EsaResolveHilPayload): InboxItem {
  const urgency =
    payload.priority.toUpperCase() === 'CRITICAL' ||
    payload.priority.toUpperCase() === 'HIGH'
      ? 'high'
      : payload.priority.toUpperCase() === 'MEDIUM'
        ? 'medium'
        : 'low';

  return {
    id: payload.hilId,
    type: 'hitl',
    status: payload.status,
    name: payload.title,
    raisedAt: payload.raisedAt,
    priority: payload.priority,
    urgency,
    attention: {
      title: payload.title,
      summary: '',
      count: 1,
      objective: '',
      solution: payload.solutionId,
      run: '',
    },
    linkedItemTitle: null,
    suggestions: payload.suggestions,
    moduleId: payload.moduleId,
    solutionId: payload.solutionId,
    agentUkey: payload.agentUkey,
    workscopeUkey: payload.workscopeUkey,
    conversationId: payload.conversationId,
    uiPresentation: null,
  };
}

export function useEsaResolveHilEvent(): void {
  useEffect(() => {
    return shellEventBus.on('ESA_RESOLVE_HIL', (event) => {
      const {
        setEsaPanelOpen,
        setEsaPanelMode,
        setResolvingTab,
      } = useShellStore.getState();
      const { startResolvingSession } = useEsaDomainStore.getState();

      const item = payloadToInboxItem(event.payload);
      const session: ResolvingSession = { items: [item], currentIndex: 0 };
      const tab = buildResolvingTabSpec(item);

      setEsaPanelOpen(true);
      startResolvingSession(session);
      setResolvingTab(tab);
      bridgeSetResolvingTab(tab);
      setEsaPanelMode('resolve');
    });
  }, []);
}
